import "./Product.module.css";
import Navigation from "@/reusable_sections/Header";
import Support from "./sections/Support";
import Testimonials from "./sections/Testimonials";
import Components from "./sections/Components";
import Order from "./sections/Order";
import Footer from "@/reusable_sections/Footer";
import ProductDetail from "./sections/ProductDetail";
export default function ProductPage() {
  return <div>
      <Navigation />
      <ProductDetail />
      <Support />
      <Testimonials />
      <Order />
      <Footer />
    </div>;
}